import { defineStore } from 'pinia'

export const useTourStore = defineStore('concerts', {
  state: () => ({
    datak: [
      // { data: '2025-11-22', herria: 'Azpeitia', kokapena: 'San Agustin Kulturgunea', link: 'https://entradium.com/events/miruaburutik', soldout: false },
      // { data: '2026-01-30', herria: 'Gasteiz', kokapena: 'Jimmy Jazz', link: '', soldout: false },
    ]
  }),
  getters: {
    tourDatak: (state) => state.datak
  },
  actions: {
   setTourDatak(data) {
      this.datak = data
    }
  }
})
